import { UIActionConstants } from "../action-constants";
import emptyState from "../store/emptyState";
import globalReducerHelper from "./globalReducerHelper";

const ui = (state = emptyState.ui, action) => {
  if (!state) return {};

  const { type, payload } = action;

  switch (type) {
    case UIActionConstants.CLIENT_INITIALIZED:
      return Object.assign({}, state, {
        clientInitialized: true
      });

    case UIActionConstants.SET_LINKS:
      return Object.assign({}, state, {
        links: action.payload
      });

    case UIActionConstants.SET_CONFIG:
      return Object.assign({}, state, {
        config: action.payload
      });

    case UIActionConstants.CREATE_FULL_SCREEN_POPUP:
      return Object.assign({}, state, {
        fullScreenPopup: payload
      });

    case UIActionConstants.SET_SCREEN_TYPE:
      return Object.assign({}, state, {
        screenType: action.payload
      });

    case UIActionConstants.SET_TOUCHID_VISIBLE:
      return Object.assign({}, state, {
        touchIdVisible: payload
      });
    case UIActionConstants.SET_TOUCHID_DATA:
      return Object.assign({}, state, {
        touchIdData: payload
      });

    case UIActionConstants.UPDATE_RIGHT_SIDE_DRAWER: {
      const { appID } = payload;
      const rightSideDrawerArr = [...state.rightSideDrawer];
      let selectedElement = rightSideDrawerArr.findIndex(
        item => item.appID === appID
      );
      if (selectedElement !== -1) {
        const updatedElement = {
          ...rightSideDrawerArr[selectedElement],
          ...payload
        };
        rightSideDrawerArr.splice(selectedElement, 1);
        rightSideDrawerArr.push(updatedElement);
      }
      return Object.assign({}, state, {
        rightSideDrawer: rightSideDrawerArr
      });
    }

    case UIActionConstants.ADD_ELEMENT_RIGHT_SIDE_DRAWER: {
      const rightSideDrawerArr = [...state.rightSideDrawer, payload];
      return Object.assign({}, state, {
        rightSideDrawer: rightSideDrawerArr
      });
    }

    case UIActionConstants.REMOVE_ELEMENT_RIGHT_SIDE_DRAWER: {
      const { appID } = payload;
      const rightSideDrawerArr = state.rightSideDrawer.filter(
        item => item.appID !== appID
      );
      return Object.assign({}, state, {
        rightSideDrawer: rightSideDrawerArr
      });
    }

    case UIActionConstants.TOGGLE_MAIN_VIEW_APP:
      return Object.assign({}, state, {
        mainViewApp: payload
      });

    case UIActionConstants.CLOSE_PANIC_TOOLTIP:
      return Object.assign({}, state, {
        panicTooltipClosed: payload
      });

    case UIActionConstants.USER_INTERACTED:
      return Object.assign({}, state, {
        userInteracted: true
      });

    case UIActionConstants.TOGGLE_BUBBLE:
      return Object.assign({}, state, {
        bubble: payload
      });

    case UIActionConstants.SET_LAST_BUBBLE_POSITION:
      return Object.assign({}, state, {
        lastBubblePosition: payload
      });

    case UIActionConstants.SET_THEME_MODE:
      return Object.assign({}, state, {
        themeMode: payload
      });

    case UIActionConstants.SET_DEVICE_ORIENTATION:
      return Object.assign({}, state, {
        orientation: payload
      });

    case UIActionConstants.DISABLE_POPUPS:
      return Object.assign({}, state, {
        popupsDisabled: payload
      });

    case UIActionConstants.RENDER_CONTROL_CENTER_MINI:
      return Object.assign({}, state, {
        controlCenterMini: payload
      });

    case UIActionConstants.SET_POPUP_VISIBILITY:
      return Object.assign({}, state, {
        isPopupVisible: payload
      });

    case UIActionConstants.SET_NO_SCROLL:
      return Object.assign({}, state, {
        noScrolls: [
          ...state.noScrolls.filter(x => x.id !== payload.id),
          payload
        ]
      });

    default:
      return globalReducerHelper(
        state,
        type,
        payload?.ui && payload,
        emptyState.ui
      );
  }
};

export default ui;
